import { otherApiClient } from "./index";
export const getPackage = async (id)=>{
    const { data  } = await otherApiClient.market("/packages/".concat(id));
    return data;
};
export const getMyPackages = async ()=>{
    const { data  } = await otherApiClient.market("/packages/purchased");
    return data;
};
